import { get } from 'lodash'

// INFO: need to convert existing type to field type
export const getPropertyOptions = (property) => {
  const { type, options = {} } = property
  let fieldType = get(property, ['options', 'fieldType'], type)
  switch (fieldType) {
    case 'integer':
      fieldType = 'number'
      break
    case 'float':
      fieldType = 'number'
      break
    case 'string':
      fieldType = 'text'
      break
    case 'boolean':
      fieldType = 'select'
      break
  }
  return {
    ...options,
    fieldType
  }
}
